import { _FavoriteIconBase, _FavoriteIconCssType } from './favoriteIconBase'

export class _FavoriteIconRectangleStar extends _FavoriteIconBase {
  cssType: _FavoriteIconCssType = 'rectangle-star'
  protected initPC(): this {
    this['--favorited-icon-top'] = '0.02rem'
    this['--favorited-icon-right'] = '0.02rem'
    this['--favorited-icon-bottom'] = 'initial'
    this['--favorited-icon-left'] = 'initial'
    return this
  }
  protected initH5(): this {
    this['--favorited-icon-top'] = '0.02rem'
    this['--favorited-icon-right'] = '0.02rem'
    this['--favorited-icon-bottom'] = 'initial'
    this['--favorited-icon-left'] = 'initial'
    return this
  }
}
